import { ProductTileContext } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/common";
import { IOnProductClickBase } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/IOnProductClickBase";
import { useProductTileClickImpressions } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/useProductTileClickImpressions";
import React, { useCallback } from "react";

export const useOnProductClickBase = <T extends IOnProductClickBase>(
  params: T
) => {
  const { brand, brandToken } = React.useContext(ProductTileContext);

  const { recordProductTileClickEvent } = useProductTileClickImpressions(
    params,
    brandToken ?? brand?.token
  );

  return useCallback(() => {
    recordProductTileClickEvent();
  }, [recordProductTileClickEvent]);
};
